export const convertEvoPrizeTypeToRewardType = (reward) => {
    const { prize_type, custom_attributes } = reward;
    if (prize_type === "simplified" && !!(custom_attributes === null || custom_attributes === void 0 ? void 0 : custom_attributes.locations)) {
        return "sensorial";
    }
    if (prize_type === "delayed_lottery_physical") {
        return "delayed_lottery";
    }
    if (prize_type === "instant_lottery_physical") {
        return "instant_lottery";
    }
    // @ts-expect-error - this value will be added in the future EVO versions
    if (prize_type === "instant_lottery_simplified") {
        return "instant_lottery";
    }
    // @ts-expect-error - this value will be added in the future EVO versions
    if (prize_type === "delayed_lottery_simplified") {
        return "delayed_lottery";
    }
    if (prize_type === "physical") {
        return "physical";
    }
    return "virtual";
};
export const convertEvoGetPrizes = (evoPrizes) => {
    var _a;
    const { data, meta } = evoPrizes;
    const convertedPrizes = data.map((prize) => {
        var _a;
        const { presentation: { images = [], name, description }, identifier: prize_uuid, brand_name: brandName, points, custom_attributes: { color, locations = [], slug }, has_coupons, created_at, levels, } = prize;
        return {
            prize_uuid,
            name,
            brandName,
            subtitle: description !== null && description !== void 0 ? description : "",
            points,
            images,
            color: color !== null && color !== void 0 ? color : "",
            has_coupons,
            created_at,
            levels: levels !== null && levels !== void 0 ? levels : [],
            locations,
            slug,
            isAddressRequired: Boolean((_a = prize === null || prize === void 0 ? void 0 : prize.custom_attributes) === null || _a === void 0 ? void 0 : _a.is_address_required),
            rewardType: convertEvoPrizeTypeToRewardType(prize),
        };
    });
    return {
        items: convertedPrizes,
        total: (_a = meta.total) !== null && _a !== void 0 ? _a : 0,
    };
};
//# sourceMappingURL=convertEvoGetPrizes.js.map